import { render, staticRenderFns } from "./main.vue?vue&type=template&id=69e6c34e&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e6c34e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69e6c34e')) {
      api.createRecord('69e6c34e', component.options)
    } else {
      api.reload('69e6c34e', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=69e6c34e&scoped=true", function () {
      api.rerender('69e6c34e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/dashboard/admin/main.vue"
export default component.exports